import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding: 20px 32px 32px;

  @media only screen and (max-width: 768px) {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;
